var React = require('react');

function Tortilla1Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"110.7","cy":"239.7","r":"65","key":0}),React.createElement("circle",{"cx":"175.6","cy":"95.6","r":"25.9","key":1}),React.createElement("path",{"d":"M409.4,52.1c21.5,0,38.8,17.4,38.8,38.8c0,14.4,11.8,25.9,25.9,25.9c14.1,0,25.9-11.8,25.9-25.9c0-50-40.6-90.9-90.9-90.9\n\tc-50,0-90.9,40.6-90.9,90.9s40.6,90.9,90.9,90.9c14.4,0,25.9-11.8,25.9-25.9c0-14.1-11.8-25.9-25.9-25.9\n\tc-21.5,0-38.8-17.4-38.8-38.8C370.6,69.4,388.2,52.1,409.4,52.1z","key":2})]);
}

Tortilla1Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 500 304.6","style":{"enableBackground":"new 0 0 500 304.6"},"xmlSpace":"preserve"};

module.exports = Tortilla1Inline;

Tortilla1Inline.default = Tortilla1Inline;
